import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';

import { PlusIcon } from '@heroicons/react/24/solid'
import ModalForm from '../../components/common/ModalForm';
import {
  CategorieForm,
  CategorieEditForm,
  FournisseurForm,
  ProduitAddForm
} from '../../config/index';
import {
  addCategorie, deleteCategorie, editCategorie, getAllCategories,
  getAllFournisseurs

} from '../../store/settingsSlice';
import CommonForm from '../../components/common/CommonForm';
import { getAllProduits } from '../../store/produitSlice';


function Categorie() {

  const { categorieList, fournisseurList } = useSelector((state) => state.settings);
  const { produitList } = useSelector((state) => state.produit);
  const [selectedCategory, setSelectedCategory] = useState();
  const [selectedFournisseur, setSelectedFournisseur] = useState();
  const [selectedProduit, setSelectedProduit] = useState();

  const [searchTermProduit, setSearchTermProduit] = useState("");
  const [filteredFournisseurs, setFilteredFournisseurs] = useState([]);
  const [filteredProduits, setFilteredProduits] = useState([]);

  useEffect(() => {
    dispatch(getAllCategories());
    dispatch(getAllFournisseurs());
    dispatch(getAllProduits());
    if (categorieList && categorieList.length > 0) {
      setSelectedCategory(categorieList[0]);
    }
    if (fournisseurList && fournisseurList.length > 0) {
      setSelectedFournisseur(fournisseurList[0]);
    }

    if (produitList && produitList.length > 0) {
      setSelectedProduit(produitList[0]);
    }
  }, [getAllCategories]);

  const [formControls, setFormControls] = useState(CategorieForm);
  const [formTitle, setformTitle] = useState("Ajouter une categorie");

  // Modal Form start here 
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({});
  const [isBtnDisabled, setIsBtnDisabled] = useState(false);
  const [mode, setMode] = useState("add");

  const dispatch = useDispatch();

  //console.log(formData, 'formdata');

  const [currentEditeId, setCurrentEditeId] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();

    currentEditeId !== null
      ? dispatch(
        editCategorie({
          id: currentEditeId,
          formData,
        })
      ).then((data) => {
        if (data?.payload?.success) {
          dispatch(getAllCategories());
          setSelectedCategory(data?.payload?.data);
          setFormData({});
          setIsModalOpen(false);// Ferme le modal aprs la soumission
        }
      })
      : dispatch(
        addCategorie(formData)).then((data) => {
          if (data?.payload?.success) {
            dispatch(getAllCategories());
            setFormData({});
            setIsModalOpen(false);// Ferme le modal après la soumission
          }
        });
  };

  function handleDelete(id) {
    // alert avec confirmation
    if (!window.confirm("Voulez-vous vraiment supprimer la catégorie : " + selectedCategory?.designation)) {
      return;
    }
    dispatch(deleteCategorie(id)).then((data) => {
      if (data?.payload?.success) {
        dispatch(getAllCategories());
        setSelectedCategory(data?.payload?.data);
        setFormData({});
        setIsModalOpen(false);// Ferme le modal aprs la soumission
      }
    });
  }

  const [searchTerm, setSearchTerm] = useState("");
  const [filteredCategories, setFilteredCategories] = useState([]);


  useEffect(() => {
    // categorie filter
    const filtered = categorieList.filter((categorie) =>
      categorie.designation.toLowerCase().includes(searchTerm.toLowerCase()));

    setSelectedCategory(filtered[0]);

    setFilteredCategories(filtered);

    // Fournisseur filter
    if (fournisseurList && fournisseurList.length > 0) {
      const filteredF = fournisseurList.filter((fournisseur) =>
        fournisseur.nomcompagnie.toLowerCase().includes(searchTerm.toLowerCase()));

      setSelectedFournisseur(filteredF[0]);


      setFilteredFournisseurs(filteredF);
    }

    // produit filter
    if (produitList && produitList.length > 0) {
      const filteredP = produitList.filter((product) =>
        product.designation.toLowerCase().includes(searchTermProduit.toLowerCase()));

      setSelectedProduit(filteredP[0]);

      setFilteredProduits(filteredP);
    }
  }, [categorieList, searchTerm, produitList, searchTermProduit, fournisseurList]);



  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleSearPchChange = (e) => {
    setSearchTermProduit(e.target.value);
  };


  function handleModal(formFourni) {

    switch (formFourni) {
      case 'categorie':
        setFormControls(CategorieForm);
        setformTitle("Ajouter une categorie");
        break;
      case 'fournisseur':
        setFormControls(FournisseurForm);
        setformTitle("Ajouter un fournisseur");
        break;
      case 'produit':
        setFormControls(ProduitAddForm);
        setformTitle("Ajouter un produit");
        break;
      case 'categorieEdit':
        setFormControls(CategorieEditForm);
        setformTitle("Modifier une categorie");
        break;
      default:
        setFormControls(CategorieForm);
        setformTitle("Ajouter une categorie");
        break;
    }

    setIsModalOpen(true);

  }

  const [activeTab, setActiveTab] = useState(0);
  const tabs = ["Details", "Fournisseurs", "Produits"];




  return (
    <div className="flex sm:flex-row md:flex-col flex-1 gap-4 bg-gray-100 md:mt-10 p-5">
      {/* Sidebar */}
      <div className="col-span-4 bg-white p-6 border rounded">
        <div className="grid grid-cols-8 mb-2 px-3 border-b">
          <PlusIcon
            onClick={() => handleModal('categorie')}
            title='Ajouter une categorie'
            className="col-span-1 pt-3 w-9 h-9 text-teal-400 cursor-pointer" />
          <form action="" className="flex col-span-7">
            <input
              className="flex-1 p-3 focus:outline-none"
              type="text"
              placeholder="Recherche..."
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </form>
        </div>

        <div className='min-h-[610px] max-h-[610px] overflow-y-scroll'>
          <h2 className="mb-4 font-bold text-lg">Catégories</h2>
          {/* item */}
          <ul className="space-y-2">
            {filteredCategories.map((categorie) => (
              <li className={`
                flex flex-row items-center hover:bg-teal-500 active:bg-teal-500 px-3 py-2
                 text-gray-600 text-left text-sm hover:text-white duration-800 cursor-pointer
                 ${categorie.id === selectedCategory?.id ? "bg-teal-500 text-white" : ""}
                 `} key={categorie.id}

                onClick={() => {
                  setSelectedCategory(categorie)
                }}
              >
                {categorie.designation}

              </li>
            ))}
          </ul>

          {/* end item */}
        </div>
      </div>

      {/* Main Content */}
      <div className="flex flex-col flex-1 bg-white p-6 border rounded">
        <div className="flex flex-col flex-1">
          <div className="relative w-full">
            {/* Tabs Header */}
            <div className="relative flex justify-center space-x-4">
              {tabs.map((tab, index) => (
                <button
                  key={index}
                  onClick={() => setActiveTab(index)}
                  className={`py-2 px-4 text-gray-500 hover:text-blue-500 transition ${activeTab === index ? "text-blue-500 border-b-2 border-blue-500" : ""
                    }`}
                >
                  {tab}
                </button>
              ))}
            </div>
            {/* Tabs Content */}
            <div className="p-4">
              {activeTab === 0 &&
                <div>

                  {/* Détails de la catégorie */}
                  {selectedCategory ? (
                    <div className="flex-1 p-6 min-h-[500px] max-h-[500px] overflow-y-scroll">
                      <div className="flex justify-between items-center mb-4">
                        <h1 className="font-bold text-2xl">{selectedCategory.designation}</h1>
                        <span
                          className={`text-sm font-medium px-3 py-1 rounded ${selectedCategory.disable ? "bg-red-500 text-white" : "bg-green-500 text-white"}`}
                        >
                          {selectedCategory.disable ? "Inactive" : "Active"}
                        </span>
                      </div>
                      <div className="space-y-4 text-gray-600">
                        {selectedCategory.description.split("\n").map((paragraph, index) => (
                          <p key={index}>{paragraph}</p>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <>
                      chargement ....
                    </>
                  )}
                  {/* Footer avec le bouton Modifier */}
                  <footer className="flex justify-between items-center p-4 border-t">
                    <button
                      onClick={() => {
                        setCurrentEditeId(selectedCategory.id);
                        handleDelete(selectedCategory.id);
                      }}
                      className="bg-red-500 hover:bg-red-600 px-4 py-2 rounded text-white transition">
                      Supprimer
                    </button>

                    <button
                      onClick={() => {
                        setCurrentEditeId(selectedCategory.id);
                        handleModal('categorieEdit');
                        setFormData(selectedCategory);
                        setMode("view");
                        setformTitle("Modifier la categorie");
                      }}
                      className="bg-blue-500 hover:bg-blue-600 px-4 py-2 rounded text-white transition">
                      Modifier
                    </button>
                  </footer>

                </div>}
              {activeTab === 1 &&
                <div>
                  <div className="grid grid-cols-8 mb-2 px-3 border-b">
                    <PlusIcon
                      onClick={() => handleModal('fournisseur')}
                      title='Ajouter une fournisseur'
                      className="col-span-1 pt-3 w-9 h-9 text-teal-400 cursor-pointer" />
                    <form action="" className="flex col-span-7">
                      <input
                        className="flex-1 p-3 focus:outline-none"
                        type="text"
                        placeholder="Recherche..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                      />
                    </form>
                  </div>


                  {/* start Fournisseurs */}
                  <table className="table-fixed w-full">

                    {/* table head */}
                    <thead className="text-left">
                      <tr>
                        <th className="pb-10 w-1/2 font-extrabold text-sm tracking-wide">Fournisseur</th>
                        <th className="text-right pb-10 w-1/4 font-extrabold text-sm tracking-wide">Téléphone</th>
                        <th className="text-right pb-10 w-1/4 font-extrabold text-sm tracking-wide">E-mail</th>
                        <th className="text-right pb-10 w-1/4 font-extrabold text-sm tracking-wide">adresss</th>
                        <th className="text-right pb-10 w-1/4 font-extrabold text-sm tracking-wide">Nb Produits</th>
                      </tr>
                    </thead>
                    {/* end table head */}

                    {/* table body */}
                    <tbody className="text-gray-600 text-left">

                      {/* item */}
                      <tr>
                        {/* name */}
                        <th className="flex flex-row items-center mb-4 w-1/2 font-extrabold text-xs tracking-wider">
                          <p className="ml-3 name-1">user name</p>
                        </th>
                        {/* name */}

                        {/* product */}
                        <th className="text-right mb-4 w-1/4 font-extrabold text-xs tracking-wider">Nike Sport</th>
                        {/* product */}

                        {/* invoice */}
                        <th className="text-right mb-4 w-1/4 font-extrabold text-xs tracking-wider">#<span className="num-4"></span>
                        </th>
                        {/* invoice */}

                        {/* price */}
                        <th className="text-right mb-4 w-1/4 font-extrabold text-xs tracking-wider">$<span className="num-2"></span>
                        </th>
                        {/* price */}

                        {/* status */}
                        <th className="text-right mb-4 w-1/4 font-extrabold text-xs tracking-wider">shipped</th>
                        {/* status */}

                      </tr>
                      {/* item */}


                      {/* item */}
                      <tr>
                        {/* name */}
                        <th className="flex flex-row items-center mb-4 w-1/2 font-extrabold text-xs tracking-wider">
                          <div className="rounded-full w-8 h-8 overflow-hidden">
                            <img src="assets/img/user3.jpg" className="object-cover" />
                          </div>
                          <p className="ml-3 name-1">user name</p>
                        </th>
                        {/* name */}

                        {/* product */}
                        <th className="text-right mb-4 w-1/4 font-extrabold text-xs tracking-wider">Nike Sport</th>
                        {/* product */}

                        {/* invoice */}
                        <th className="text-right mb-4 w-1/4 font-extrabold text-xs tracking-wider">#<span className="num-4"></span>
                        </th>
                        {/* invoice */}

                        {/* price */}
                        <th className="text-right mb-4 w-1/4 font-extrabold text-xs tracking-wider">$<span className="num-2"></span>
                        </th>
                        {/* price */}

                        {/* status */}
                        <th className="text-right mb-4 w-1/4 font-extrabold text-xs tracking-wider">shipped</th>
                        {/* status */}

                      </tr>
                      {/* item */}


                      {/* item */}
                      <tr>
                        {/* name */}
                        <th className="flex flex-row items-center mb-4 w-1/2 font-extrabold text-xs tracking-wider">
                          <div className="rounded-full w-8 h-8 overflow-hidden">
                            <img src="assets/img/user2.jpg" className="object-cover" />
                          </div>
                          <p className="ml-3 name-1">user name</p>
                        </th>
                        {/* name */}

                        {/* product */}
                        <th className="text-right mb-4 w-1/4 font-extrabold text-xs tracking-wider">Nike Sport</th>
                        {/* product */}

                        {/* invoice */}
                        <th className="text-right mb-4 w-1/4 font-extrabold text-xs tracking-wider">#<span className="num-4"></span>
                        </th>
                        {/* invoice */}

                        {/* price */}
                        <th className="text-right mb-4 w-1/4 font-extrabold text-xs tracking-wider">$<span className="num-2"></span>
                        </th>
                        {/* price */}

                        {/* status */}
                        <th className="text-right mb-4 w-1/4 font-extrabold text-xs tracking-wider">shipped</th>
                        {/* status */}

                      </tr>
                      {/* item */}

                      {/* item */}
                      <tr>
                        {/* name */}
                        <th className="flex flex-row items-center mb-4 w-1/2 font-extrabold text-xs tracking-wider">
                          <div className="rounded-full w-8 h-8 overflow-hidden">
                            <img src="assets/img/user1.jpg" className="object-cover" />
                          </div>
                          <p className="ml-3 name-1">user name</p>
                        </th>
                        {/* name */}

                        {/* product */}
                        <th className="text-right mb-4 w-1/4 font-extrabold text-xs tracking-wider">Nike Sport</th>
                        {/* product */}

                        {/* invoice */}
                        <th className="text-right mb-4 w-1/4 font-extrabold text-xs tracking-wider">#<span className="num-4"></span>
                        </th>
                        {/* invoice */}

                        {/* price */}
                        <th className="text-right mb-4 w-1/4 font-extrabold text-xs tracking-wider">$<span className="num-2"></span>
                        </th>
                        {/* price */}

                        {/* status */}
                        <th className="text-right mb-4 w-1/4 font-extrabold text-xs tracking-wider">shipped</th>
                        {/* status */}

                      </tr>
                      {/* item */}

                      {/* item */}
                      <tr>
                        {/* name */}
                        <th className="flex flex-row items-center mb-4 w-1/2 font-extrabold text-xs tracking-wider">
                          <div className="rounded-full w-8 h-8 overflow-hidden">
                            <img src="assets/img/user3.jpg" className="object-cover" />
                          </div>
                          <p className="ml-3 name-1">user name</p>
                        </th>
                        {/* name */}

                        {/* product */}
                        <th className="text-right mb-4 w-1/4 font-extrabold text-xs tracking-wider">Nike Sport</th>
                        {/* product */}

                        {/* invoice */}
                        <th className="text-right mb-4 w-1/4 font-extrabold text-xs tracking-wider">#<span className="num-4"></span>
                        </th>
                        {/* invoice */}

                        {/* price */}
                        <th className="text-right mb-4 w-1/4 font-extrabold text-xs tracking-wider">$<span className="num-2"></span>
                        </th>
                        {/* price */}

                        {/* status */}
                        <th className="text-right mb-4 w-1/4 font-extrabold text-xs tracking-wider">shipped</th>
                        {/* status */}

                      </tr>
                      {/* item */}




                    </tbody>
                    {/* end table body */}

                  </table>
                  {/* end Fournisseur */}

                </div>}
              {activeTab === 2 &&
                <div>
                  <div className="grid grid-cols-8 mb-2 px-3 border-b">
                    <PlusIcon
                      onClick={() => handleModal('produit')}
                      title='Ajouter un produit'
                      className="col-span-1 pt-3 w-9 h-9 text-teal-400 cursor-pointer" />
                    <form action="" className="flex col-span-7">
                      <input
                        className="flex-1 p-3 focus:outline-none"
                        type="text"
                        placeholder="Recherche..."
                        value={searchTermProduit}
                        onChange={handleSearPchChange}
                      />
                    </form>
                  </div>
                  {/* start Fournisseurs */}
                  <table className="table-fixed w-full">

                    {/* table head */}
                    <thead className="text-left">
                      <tr className=''>
                        <th className="pb-2 pl-2 font-extrabold text-left text-sm tracking-wide">Produit</th>
                        <th className="pb-2 pl-2 font-extrabold text-left text-sm tracking-wide">Description</th>
                        <th className="pb-2 pl-2 font-extrabold text-left text-sm tracking-wide">Prix KMF</th>
                        <th className="pb-2 pl-2 font-extrabold text-left text-sm tracking-wide">Qt Stock</th>
                        <th className="pb-2 pl-2 font-extrabold text-left text-sm tracking-wide">Stock Min</th>
                      </tr>
                    </thead>
                    {/* end table head */}

                    {/* table body */}
                    <tbody className="text-gray-600 text-sm">
                      {filteredProduits.map((produit) => (
                        <tr
                          className="hover:bg-teal-500 hover:text-white hover:cursor-pointer"

                          key={produit.id}

                          onClick={() => {
                            setSelectedProduit(produit)
                          }}
                        >

                          {/* name */}
                          <td className="border-1 px-2 py-1 border">
                            {produit.designation}
                          </td>
                          {/* name */}

                          {/* product */}
                          <td className="px-2 py-1 border border-l-0">
                            {produit.unite}
                          </td>
                          {/* product */}

                          {/* invoice */}
                          <td className="px-2 py-1 border border-l-0">{produit.prix} </td>
                          {/* invoice */}

                          {/* price */}
                          <td className="px-2 py-1 border border-l-0">{produit.stockqty}</td>
                          {/* price */}

                          {/* status */}
                          <td className="px-2 py-1 border border-l-0">{produit.alertstockqty}</td>
                          {/* status */}

                        </tr>

                      ))}

                    </tbody>
                    {/* end table body */}

                  </table>
                  {/* end Fournisseur */}
                </div>}
            </div>
          </div>
        </div>
        <div className="flex justify-between card-footer">
          <p>4.41 GB (25%) of 17 GB used Manage</p>
          <p>Last account activity: 36 minutes ago</p>
        </div>
      </div>
      <ModalForm
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        children={
          <CommonForm
            formTitle={formTitle}
            formControls={formControls}
            formData={formData}
            mode={mode}
            setFormData={setFormData}
            handleSubmit={handleSubmit}
            isBtnDisabled={isBtnDisabled}
          />
        }
      />
    </div>

  )
}

export default Categorie